import type React from 'react'
import type { IconProps } from './types'

/**
 * HrFlagIcon — Lucide-style flag glyph used for the HR Review Flags entry
 * in the admin sidebar. Stroke-based (matching Lucide's source) rather than
 * filled — kept stroked because the silhouette reads cleaner at the small
 * sizes the sidebar uses.
 *
 * Geometry follows lucide.dev/icons/flag:
 *  - flag pole: vertical line on the left
 *  - flag fabric: a curved quadrilateral flying to the right
 */
const HrFlag: React.FC<IconProps> = ({ size = 20, className = 'text-neutral-900' }) => (
	<svg
		width={size}
		height={size}
		viewBox='0 0 24 24'
		className={className}
		fill='none'
		stroke='currentColor'
		strokeWidth={2}
		strokeLinecap='round'
		strokeLinejoin='round'
		xmlns='http://www.w3.org/2000/svg'
		aria-hidden='true'>
		<path d='M4 15s1-1 4-1 5 2 8 2 4-1 4-1V3s-1 1-4 1-5-2-8-2-4 1-4 1z' />
		<line x1='4' y1='22' x2='4' y2='15' />
	</svg>
)

export default HrFlag
